var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import theme from '@adsk/alloy-react-theme';
import AlloyCheckbox from '@adsk/alloy-react-checkbox';
import { useLocale } from '@adsk/alloy-react-locale';
var HeaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  position: static;\n  bottom: 0;\n  align-items: center;\n  padding: 12px 16px 12px;\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  position: static;\n  bottom: 0;\n  align-items: center;\n  padding: 12px 16px 12px;\n  border-bottom: 1px solid ", ";\n"])), theme.colors.charcoal200);
var Label = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  ", "\n  display: flex;\n  line-height: 20px;\n  color: ", ";\n"])), __assign({}, theme.typography.bodyMedium), theme.colors.charcoal900);
var IncludeUnspecifiedWrapper = styled(Label)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Checkbox = styled(AlloyCheckbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
Checkbox.displayName = 'Checkbox';
export var CardHeader = function (_a) {
    var _b = _a.includeUnspecified, includeUnspecified = _b === void 0 ? false : _b, _c = _a.onUnspecifiedSelect, onUnspecifiedSelect = _c === void 0 ? function (includeUnspecified) { } : _c;
    var T = useLocale(function (_a) {
        var locale = _a.locale;
        return require("../i18n/".concat(locale, ".json"));
    }).T;
    return (React.createElement(HeaderContainer, null,
        React.createElement(IncludeUnspecifiedWrapper, null,
            React.createElement(Checkbox, { checked: includeUnspecified, onChange: function (val) { return onUnspecifiedSelect(val === true); } }),
            T.translate('cardHeader.unspecified'))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
